import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import CommonModal from "./CommonModal";
import Cancel from "../buttons/Cancel";
import Reset from "./../buttons/Reset";
import Submit from "./../buttons/Submit";
import { useSelector } from "react-redux";
import { Spinner } from "@material-tailwind/react";
import Utility from "../../Utils/Utility";
import { HttpClient } from "../../Redux/controllers/HttpClient";
import { SlReload } from "react-icons/sl";
import { useModal } from "../../context/modalContext";
import ToggleButton from "../buttons/Toggle";

const validationSchema = Yup.object().shape({
  orderName: Yup.string()
    // .matches(/^[A-Za-z]+$/, "Order  name must contain only alphabets")
    .required("Order Name is required"),
  // type: Yup.string().required("Type required"),
  code: Yup.string().required("Code required"),
});

const DrugCodeModal = ({ onClose, edit }) => {
  const { userID } = useModal();

  const { token } = useSelector((state) => state.user);
  const [showSpin, setShowSpin] = useState(false);

  const formik = useFormik({
    initialValues: {
      orderName: edit ? userID?.name : "",
      type: edit ? userID?.type : "",
      code: edit ? userID?.code : "",
    },
    validationSchema: validationSchema,
    onSubmit: edit ? handleEditSubmit : handleSubmit,
  });

  async function handleSubmit(values) {
    setShowSpin(true);
    let userData = {
      name: values?.orderName,
      // type: values?.type,
      code: values?.code,
    };
    try {
      const res = await HttpClient.apiCaller(
        "admin/add-drug-code",
        "POST",
        userData,
        token,
        null
      );
      console.log(res);
      Utility.sToast("Data posted successfully");
      onClose();
      formik.resetForm();
    } catch (err) {
      console.log(err);
      Utility.eToast(err?.response?.data?.err || "Something went wrong");
    } finally {
      setShowSpin(false);
    }
  }

  async function handleEditSubmit(values) {
    setShowSpin(true);
    let userData = {
      _id: userID._id,
      name: values?.orderName,
      // type: values?.type,
      code: values?.code,
    };
    try {
      const res = await HttpClient.apiCaller(
        "admin/update-drug-code",
        "PUT",
        userData,
        token,
        null
      );
      console.log(res);
      Utility.sToast("Code Updated successfully");
      onClose();
      formik.resetForm();
    } catch (err) {
      console.log(err);
      Utility.eToast("Something went wrong");
    } finally {
      setShowSpin(false);
    }
  }

  const handleReset = () => {
    formik.resetForm();
  };

  return (
    <CommonModal
      heading={edit ? "Edit Drug Code" : "Add Drug Code"}
      onClose={onClose}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="mt-9">
          <p className="mb-2 poppins-medium">Drug code name</p>
          <input
            type={"text"}
            placeholder="Enter drug code name"
            className="w-full h-10 mb-2 rounded poppins-regular bg-[#ECF1F6] p-2"
            onChange={formik.handleChange}
            name="orderName"
            value={formik.values.orderName}
          />
          {formik.errors.orderName && formik.touched.orderName && (
            <div className="text-red-500 poppins-regular ml-1 text-sm">
              {formik.errors.orderName}
            </div>
          )}
          {/* <p className="mb-2 poppins-medium">Select type</p>
          <select
            id="countries"
            className="custom-input"
            value={formik.values.type}
            onChange={formik.handleChange}
            name="type"
          >
            <option value="">Select Type</option>
            <option value="SPECIMEN">SPECIMEN</option>
            <option value="DRUG">DRUG</option>
            <option value="ORDER">ORDER</option>
          </select>
          {formik.errors.type && formik.touched.type && (
            <div className="text-red-500 poppins-regular ml-1 text-sm">
              {formik.errors.type}
            </div>
          )} */}
          <p className="mb-2 poppins-medium">Enter code</p>
          <input
            type={"text"}
            placeholder="Enter drug code"
            className="w-full h-10 mb-2 rounded poppins-regular bg-[#ECF1F6] p-2"
            value={formik.values.code}
            onChange={formik.handleChange}
            name="code"
          />
          {formik.errors.code && formik.touched.code && (
            <div className="text-red-500 poppins-regular ml-1 text-sm">
              {formik.errors.code}
            </div>
          )}
        </div>

        {/* <div className="mt-4 mb-7">
          <ToggleButton onClick={() => { }} />
        </div> */}

        {/* Footer */}
        <div className="flex justify-between mt-3">
          <div>
            {!edit ? (
              <button
                type="button"
                onClick={handleReset}
                className="flex items-center px-2 py-1  poppins-medium border-2  border-gray-400 rounded hover:opacity-80 bg-[#ECF1F6]"
              >
                <SlReload className="mr-1" />
                Reset
              </button>
            ) : (
              <></>
            )}
          </div>
          <div className="flex gap-4 ml-auto">
            <Cancel onClick={onClose} />
            <Submit
              label={
                showSpin ? (
                  <Spinner color="white" />
                ) : edit ? (
                  "Save Changes"
                ) : (
                  "submit"
                )
              }
            />
          </div>
        </div>
      </form>
    </CommonModal>
  );
};

export default DrugCodeModal;
